import '@babel/polyfill'

import Vue from 'vue'

import BouncePreventor from '@/shared/components/BouncePreventor/BouncePreventor.vue'

/* eslint-disable no-new */
new Vue({
  el: '#v-app-catalog-list',
  components: {
    BouncePreventor
  }
})



// WEBPACK FOOTER //
// ./WebResources/vue/catalog/list/main.js